export interface SingleErrorMessage {
	lang: string;
	key: string;
	label: string;
}

const model: types.models.InputModel = {
	lang: 'lang',
	key: 'key',
	label: 'label',
};

export default model;
